import { useState, useEffect } from 'react';

export function useTourState(tourKey: string, enabled: boolean) {
  const [run, setRun] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const seen = localStorage.getItem(tourKey);
    if (!seen) {
      const timer = setTimeout(() => setRun(true), 1000);
      return () => clearTimeout(timer);
    }
  }, [tourKey, enabled]);

  const complete = () => {
    localStorage.setItem(tourKey, 'true');
    setRun(false);
  };

  return { run, complete };
}
